export default __webpack_public_path__ + "static/media/icon_webhooks.0a1fcadf.svg";